import imageTransform from 'foundation/js/imageTransformation/imageTransform'
import { locationCard_5_4 } from 'foundation/js/imageTransformation/imagePresets'

export default {
    name: 'LocationCard',
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    setup() {
        const transformImage = (imageUrl) =>
            imageTransform(imageUrl, locationCard_5_4)
        return { transformImage }
    }
}
